import type { Root } from "mdast";
import type { TextDirective } from "mdast-util-directive";
import { visit } from "unist-util-visit";

const SAFE_URL_PATTERN = /^(https?:\/\/|mailto:)/i;

const isSafeUrl = (url: string): boolean => {
  if (!url) return false;

  // Strip C0/C1 control characters, delete, and whitespace that browsers
  // silently remove during URL parsing (per WHATWG URL spec)
  // eslint-disable-next-line no-control-regex
  const normalized = url.replace(/[\u0000-\u0020\u007f]/g, "");

  return SAFE_URL_PATTERN.test(normalized);
};

export const remarkLinkDirective = () => {
  return (tree: Root) => {
    visit(tree, "textDirective", (node: TextDirective) => {
      if (node.name !== "a") return;

      const href = node.attributes?.href;
      const target = node.attributes?.target;

      if (!href || !isSafeUrl(href)) {
        // Unsafe URL: render as plain text (keep children, remove directive)
        node.data = {
          ...node.data,
          hName: "span",
        };
        return;
      }

      const hProperties: Record<string, string> = { href };

      if (target === "_blank") {
        hProperties.target = "_blank";
        hProperties.rel = "noopener noreferrer";
      }

      node.data = {
        ...node.data,
        hName: "a",
        hProperties,
      };
    });
  };
};
